import { render, staticRenderFns } from "./InstallPWAView.vue?vue&type=template&id=496de3bd&scoped=true&"
import script from "./InstallPWAView.vue?vue&type=script&lang=ts&"
export * from "./InstallPWAView.vue?vue&type=script&lang=ts&"
import style0 from "./InstallPWAView.vue?vue&type=style&index=0&id=496de3bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496de3bd",
  null
  
)

export default component.exports